import { enumPlanRoles } from "@coreapp/constants";
import { Action, Topbox, topboxHandler } from "../Chart/NewDocForm";

export type PlanFormState = {
  name: string;
  description: string;
  levels: number;
  objective: string;
  isDirty: boolean;
  topbox?: Topbox;
  sharedWith: any[];
  emailInvite: boolean;
  defaultRole?: string;
};

export const planFormReducer = (state: PlanFormState, action: Action) => {
  const dirtyState = { ...state, isDirty: true };

  switch (action.type) {
    case "SET_NAME":
      return { ...dirtyState, name: action.payload };
    case "SET_DESCRIPTION":
      return { ...dirtyState, description: action.payload };
    case "SET_LEVELS":
      return { ...dirtyState, levels: action.payload };
    case "SET_TOPBOX":
      return topboxHandler<PlanFormState>(action, dirtyState);
    case "SET_OBJECTIVE":
      return { ...dirtyState, objective: action.payload };
    case "SET_SHARED_WITH":
      const sharedWith = [...dirtyState.sharedWith];
      const sharedWithUsernames = sharedWith.map((user: any) => user.username);
      const clearEmailInvite = action.clearEmailInvite || false;

      action.payload.forEach((user: any) => {
        const existingUserIndex = sharedWithUsernames.indexOf(user.username);
        if (existingUserIndex === -1) {
          if (!user.editorRole) {
            user.editorRole = dirtyState.defaultRole || enumPlanRoles.collaborator;
          }
          sharedWith.push(user);
        } else {
          if (user.editorRole) {
            sharedWith[existingUserIndex].editorRole = user.editorRole;
          }
        }
      });

      if (sharedWith.length === 0 && clearEmailInvite) {
        dirtyState.emailInvite = false;
      }

      return { ...dirtyState, sharedWith };
    case "RESET_SHARED_WITH":
      return {
        ...dirtyState,
        sharedWith: [],
        emailInvite: false
      };
    case "REMOVE_SHARED_WITH":
      return {
        ...dirtyState,
        sharedWith: dirtyState.sharedWith.filter((user: any) => user.username !== action.payload)
      };
    case "SET_SHARED_WITH_ROLE":
      return {
        ...dirtyState,
        sharedWith: dirtyState.sharedWith.map((user: any) => {
          if (user.username === action.payload.username) {
            user.editorRole = action.payload.role;
          }
          return user;
        })
      };
    case "SET_EMAIL_INVITE":
      return { ...dirtyState, emailInvite: action.payload };
    case "SET_DEFAULT_ROLE":
      return { ...dirtyState, defaultRole: action.payload };
    default:
      return state;
  }
};
